import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        padding: theme.spacing(5, 4),
    },
    accountTextField: {
        marginBottom: theme.spacing(0.75),
    },
}));
